module.exports = __webpack_public_path__ + "static/social-berlinguide-25d090558ad99e019644b2022dc3abf5.jpg";